import { useState, useEffect } from "react";
import { AppBar, Toolbar, Box, IconButton, Button, Link } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "./components/Logo";
import MobileDrawer from "./components/MobileDrawer";
import { useStore } from "../../_Store";
import Ajouter from "./components/Ajouter";

export default function Header() {
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [navItems, setNavItems] = useState([
    { name: t("actions.Login"), to: "/login" },
  ]);
  const {
    logout,
    state: {
      auth: { isAuth },
    },
  } = useStore();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    if (isAuth) {
      setNavItems([{ name: "Déconnexion", onClick: () => logout() }]);
    } else {
      setNavItems([{ name: t("actions.Login"), to: "/login" }]);
    }
  }, [isAuth]);

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar sx={{ zIndex: 10 }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Box
              sx={(theme) => ({
                display: "flex",
                marginLeft: `-${theme.spacing(3)}`,
              })}
            >
              <Link component={RouterLink} to={isAuth ? "/farms" : "/"}>
                <Logo />
              </Link>
              {isAuth ? (
                <Box
                  sx={(theme) => ({
                    display: { xs: "none", sm: "block" },
                    marginRight: `-${theme.spacing(3)}`,
                  })}
                >
                  <Ajouter />
                </Box>
              ) : null}
            </Box>
          </Box>

          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <Box
            sx={(theme) => ({
              display: { xs: "none", sm: "block" },
              marginRight: `-${theme.spacing(3)}`,
            })}
          >
            {navItems.map((item) => (
              <Button
                key={item.name}
                component={RouterLink}
                to={item.to ? item.to : false}
                onClick={item.onClick ? item.onClick : () => { }}
                sx={{
                  color: "#fff",
                  borderLeft: 1,
                  borderColor: "#FFFFFF4D",
                  height: { lg: "68px" },
                  px: 3,
                }}
              >
                {item.name}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>

      <MobileDrawer
        open={mobileOpen}
        onClose={handleDrawerToggle}
        navItems={navItems}
      />
    </Box>
  );
}
